<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 16:24:25
 * @LastEditTime: 2021-07-15 11:31:38
 * @LastEditors: lyy
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\components\HeadSearch.vue
 * @Description: 业务搜索控件
 */
 -->
<template>
  <div id="head-search">
    <form action="/" class="search head-search">
      <van-search
        v-model="searchStr"
        :placeholder="placeholderVal"
        :show-action="showAction"
        @search="onSearch"
        @cancel="onCancel"
        @focus="onSearchFocus"
        @blur="onSearchBlur"
        action-text="取消"
        shape="round"
        background="#FFFFFF"
      >
        <template #left-icon>
          <img src="../assets/img/common/sousuo.png" class="search-icon" />
        </template>
      </van-search>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    // 搜索输入框的提示语
    placeholder: {
      type: String,
      default: '请输入单位名称'
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchStr: this.value,
      showAction: false,
      data: {},
      placeholderVal: '' // 搜索输入框的提示语
    }
  },
  watch: {
    placeholder: {
      handler(newValue) {
        this.placeholderVal = newValue
      },
      deep: true,
      immediate: true // 第一次赋值也要触发监听
    },
    searchStr: {
      handler(newValue) {
        this.$emit('input', newValue)
      }
    },
    value: {
      handler(newValue) {
        this.searchStr = newValue
      }
    }
  },
  methods: {
    onSearch() {
      console.log('----搜索----', this.searchStr)
      this.showAction = false
      this.$emit('searchQuery', this.searchStr)
    },
    onCancel() {
      console.log('取消', this.searchStr)
      this.searchStr = ''
      this.$emit('searchCancel')
    },
    onSearchFocus() {
      this.showAction = true
    },
    onSearchBlur() {
      setTimeout(() => {
        this.showAction = false
      }, 1000 * 0.1)
    }
  },
  mounted() {}
}
</script>

<style scoped lang="scss">
.search {
  width: 100%;
  border-bottom: 1px solid #dddddd;
  position: fixed;
  z-index: 1;
  .search-icon {
    width: 14px;
    padding-right: 6px;
  }
  ::v-deep .van-search {
    padding: 8px 13px;
  }
  ::v-deep .van-field__left-icon {
    display: flex;
    align-items: center;
  }
  ::v-deep .van-field__control {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    // color: #999999;
  }
  ::v-deep .van-search__content {
    background-color: #f4f4f4;
    border: 1px solid #dddddd;
    height: 28px;
    display: flex;
    align-items: center;

    // border-radius: 14px;
  }
  ::v-deep .van-icon-search {
    color: #666666;
  }
}
/*.search .i-search {*/
/*color: gray;*/
/*position: absolute;*/
/*!*top: .9rem;*!*/
/*top: 1.2rem;*/
/*left: 8%;*/
/*}*/
/*.search input {*/
/*width: 80%;*/
/*border: 0;*/
/*height: 35px;*/
/*border-radius: 1rem;*/
/*padding: .3rem .6rem .3rem 2.5rem;*/
/*transition: all .3s ease-in-out;*/
/*}*/
/*.search .close {*/
/*color: #9A9A9A;*/
/*position: absolute;*/
/*!*top: .8rem;*!*/
/*top:1.05rem;*/
/*right: 1rem;*/
/*transition: all .3s ease-in-out;*/
/*}*/
</style>
